import * as moment from 'moment-timezone';
import { IFollowUp } from './follow-up';

export interface IFollowUpFormData
  extends Pick<IFollowUp, 'createFollowUp' | 'noFollowUpReason'> {
  followUpDate: moment.Moment;
}
